import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { Box, Typography } from '@mui/material';

import { BLACK, FEED_BACK, PRIMARY_PURPLE, RED } from '../../theme/colorConstants';
import { PRIMARY_FONT } from '../../theme/fontConstants';

const USER_SEARCH_DROPDOWN_MIN_WIDTH = 360;

const STATUS_CHIPS = {
  active: {
    labelKey: 'user.status.active',
    background: FEED_BACK.GREEN_90,
    color: FEED_BACK.GREEN_70,
  },
  onboardingIncomplete: {
    labelKey: 'userSearch.status.onboarding',
    background: PRIMARY_PURPLE[20],
    color: PRIMARY_PURPLE[90],
  },
  deactivated: {
    labelKey: 'user.status.deactivated',
    background: RED[0],
    color: RED[70],
  },
};

const OTHER_STATUS_KEYS = {
  inactive: 'user.status.inactive',
  suspended: 'user.status.suspended',
  unverified: 'user.status.unverified',
  DNA: 'user.status.DNA',
  locked: 'user.status.locked',
};

const NEUTRAL_CHIP = {
  background: BLACK[20],
  color: BLACK[70],
};

const formatUserIdLine = (id) => {
  if (id == null || id === '') return '';
  const value = String(id);
  const suffix = value.length <= 6 ? value : value.slice(-6);
  return `ID ...${suffix}`;
};

const getUserStatus = (user) => user?.status || user?.state?.status;

const getStatusChip = (status) => {
  if (STATUS_CHIPS[status]) return STATUS_CHIPS[status];
  const labelKey = OTHER_STATUS_KEYS[status];
  if (!labelKey) return null;
  return { ...NEUTRAL_CHIP, labelKey };
};

const UserSearchOption = ({ user }) => {
  const chip = getStatusChip(getUserStatus(user));

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2px', width: '100%', minWidth: 0 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: 0 }}>
        <Typography
          sx={{
            fontFamily: PRIMARY_FONT[500],
            fontSize: '14px',
            color: BLACK[100],
            lineHeight: '20px',
          }}
        >
          {user?.name}
        </Typography>
        {chip && (
          <Box
            component="span"
            data-testid="user-search-status"
            sx={{
              backgroundColor: chip.background,
              color: chip.color,
              borderRadius: '999px',
              px: '8px',
              py: '2px',
              fontSize: '12px',
              fontFamily: PRIMARY_FONT[500],
              lineHeight: '16px',
              whiteSpace: 'nowrap',
            }}
          >
            {LanguageConverterV2(chip.labelKey)}
          </Box>
        )}
      </Box>
      <Typography
        sx={{
          fontSize: '12px',
          color: BLACK[60],
          fontFamily: PRIMARY_FONT[400],
          lineHeight: '16px',
        }}
      >
        {formatUserIdLine(user?._id)}
      </Typography>
    </Box>
  );
};

UserSearchOption.propTypes = {
  user: PropTypes.shape({
    _id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    status: PropTypes.string,
    state: PropTypes.shape({
      status: PropTypes.string,
    }),
  }),
};

UserSearchOption.defaultProps = {
  user: undefined,
};

export { USER_SEARCH_DROPDOWN_MIN_WIDTH };
export default UserSearchOption;
